export default {
	id: "terrarium",
	pride: 8192,
	slug: "terrarium",
	category: "game",
	completeness: "partial",
	status: "development",
	titleKey: {
		zh: "生态缸"
	},
	descriptionKey: {
		zh: "走出实验室、野外模拟，达成「文化涌现」里程碑。向 AI 原生游戏推进中。"
	},
	date: { year: 2026, month: 6 },
	genres: ["模拟", "AI"],
	themes: ["文化涌现", "生态"],
	tags: ["AI原生游戏"]
};
